<template>
  <div class="landing-wellcome">
    <div class="container">
        <div class="left-content">
            <h1 data-aos="fade-up" data-aos-duration="1000">{{ $t('landing.wellcome.title', 'landing') }}</h1>
            <p data-aos="fade" data-aos-duration="1000" data-aos-delay="500">{{ $t('landing.wellcome.description', 'landing') }}</p>
            <p class="apps-top-text" 
                data-aos="fade" data-aos-duration="1000" data-aos-delay="500">{{ $t('landing.wellcome.apps_top_text', 'landing') }}</p>
            <div class="apps" data-aos="fade" data-aos-duration="1000" data-aos-delay="500">
                <a :href="links('app_ios')" target="_blank"><img class="apple" src="@/assets/img/wellcome_apple.png"></a>
                <a :href="links('app_android')" target="_blank"><img class="google" src="@/assets/img/wellcome_google.png"></a>
            </div>    
        </div>
        <img class="device" src="@/assets/img/Masinas_02_croped.png" data-aos="fade-left" data-aos-duration="500">
    </div>
  </div>
</template>

<script>

export default {
    name      : 'Wellcome',
    components: {
    },
    data () {
        return {
        }
    },
    watch: {
    },
    mounted () {
    },
    computed: {
    },
    methods: {
        a() {

        }
    },
}
</script>

<style scoped lang="scss">
    @import '@/assets/scss/_variables.scss';

    .landing-wellcome { 
        background-color: $teal;
        padding-bottom: 258px;
        overflow: auto;

        .container {
            position: relative;
        }

        .left-content {
            max-width: 650px;
            position: relative;
            z-index: 1;
            overflow: auto;
        }

        h1 {
            margin-top: 109px;
            font-family: 'Robusta TL Pro';
            font-style: normal;
            font-weight: 900;
            font-size: 55px;
            line-height: 80px;
            text-transform: uppercase;
            /* white */
            color: #FFFFFF;
            text-shadow: 1px 1px 1px $teal, 1px 1px 2px $teal;
        }

        p {
            margin-top: 30px;
            margin-bottom: 25px;
            font-family: 'Rubik';
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 25px;

            /* or 139% */

            /* dark blue */
            color: #194F90;

            text-shadow: 1px 1px 1px $teal, 1px 1px 2px $teal;

            &.apps-top-text {
                margin-bottom: 25px;
            }
        }

        .google {
            margin-left: 35px;
        }

        .device {
            //margin-top: 90px;
            position: absolute;
            right: 0;
            top: 0;
            margin-top: 80px;
        }
    }

    @media only screen and (max-width: $break-xl){
        .landing-wellcome { 

            .left-content {
            }

            h1 {
                text-shadow: none;
            }

            p {
                text-shadow: none;
            }

            .device {
                opacity: 0.5;
            }
        }
    }

    @media only screen and (max-width: $break-md){
        .landing-wellcome { 
            .device {
                max-width: 70%;
                display: none;
            }

            h1 {
                margin-top: 50px;
                padding-top: 20px;
                background-image: url('../../../../assets/img/Masinas_02_bleak.png');
                background-size: contain;
                background-repeat: no-repeat;
                background-position-x: right;
            }

            p {
                font-size: 16px;
                line-height: 20px;
            }
        }
    }

    @media only screen and (max-width: $break-sm){
        .landing-wellcome { 
            padding-bottom: 140px;

            h1 {
                //margin-top: 70px;
                font-size: 40px;
                line-height: 50px;
            }

            p {
                margin-bottom: 25px;
            }

            .apps {
                display: flex;
                width: 100%;
                justify-content: space-between;

                >* {
                    //width: 50%;

                    img {
                        height: 60px;
                    }
                }

                .google {
                    margin-left: 0;
                }
            }
        }
    }

    @media only screen and (max-width: $break-xs){
        .landing-wellcome { 
            .apps {
                >* {
                    img {
                        height: 50px;
                    }
                }
            }
        }
    }

    @media only screen and (max-width: $break-xxs){
        .landing-wellcome { 
            .apps {
                >* {
                    img {
                        height: 45px;
                    }
                }
            }
        }
    }
</style>